/* eslint-disable */
import { FormEditFieldCreateDialogView, FormEditFieldDialogViewFactory, FormEditFieldUpdateDialogView, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import { FormEditCreateUpdateListItemFieldDialogComponent } from '../../admin/form/form-edit/dialogs/fields/list-item/create-update/form-edit-create-update-list-item-field-dialog.component';
/* eslint-enable */

/**
 * ListItem field implementation.
 */
export class FormEditListItemFieldDialogViewFactory implements FormEditFieldDialogViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createCreateView(): ComponentRef<FormEditFieldCreateDialogView> {
    return this.createView();
  }

  createUpdateView(): ComponentRef<FormEditFieldUpdateDialogView> {
    return this.createView();
  }

  private createView(): ComponentRef<FormEditCreateUpdateListItemFieldDialogComponent> {
    return this.cfr.resolveComponentFactory(FormEditCreateUpdateListItemFieldDialogComponent)
      .create(this.injector);
  }

}
